import React from 'react';
import { observer } from 'mobx-react';

import { withConditional } from 'legacyComponents/hoc/conditional';

import { Field } from 'libs/forms/views/field';
import { Validation as ValidationComponent } from 'libs/forms/views/validation';
import { InputWrapper, WrappedInput, SuffixStyled } from 'libs/forms/styles';
import { StringFieldStore } from 'libs/forms/fieldStores';

import i18next from 'i18next';

const Validation = withConditional(ValidationComponent);

@observer
export class TextField extends Field {
  static defaultStore = StringFieldStore;
  focusAfterDelete = () => {
    const { fieldStore } = this.props;
    if (fieldStore.ref) fieldStore.ref.focus();
    fieldStore.SetFocus(true);
  };

  render() {
    const { fieldStore, editComponent, noValidation, responsive } = this.props;
    const Tag = editComponent || InputWrapper;
    let { value } = fieldStore;
    const { conf } = fieldStore;
    if (conf.prefixValue) {
      value = fieldStore.conf.prefixValue + fieldStore.value;
    }
    // if (fieldStore.conf.suffixValue) {
    //   value = fieldStore.value + fieldStore.conf.suffixValue;
    // }
    if (value === undefined) value = '';
    return (
      <Tag
        focussed={fieldStore.isFocussed}
        responsive={responsive}
        position='relative'
      >
        <WrappedInput
          ref={ref => {
            fieldStore.SetRef(ref);
          }}
          autoFocus={fieldStore.autoFocus}
          type='text'
          id={this.inputId}
          className='inputNoBorder'
          // eslint-disable-next-line
          value={value}
          placeholder={
            fieldStore.conf.placeholder &&
            i18next.t(fieldStore.conf.placeholder)
          }
          onBlur={this.onBlur}
          onChange={this.updateValue}
          onFocus={this.onFocus}
          posting={
            fieldStore.formStore.posting
              ? fieldStore.formStore.posting
              : undefined
          }
          autoComplete='off'
          responsive={responsive}
        />
        {conf.suffixValue ? (
          <SuffixStyled>{conf.suffixValue}</SuffixStyled>
        ) : null}
        {noValidation ? (
          ''
        ) : (
          <Validation
            fieldStore={fieldStore}
            handleClick={this.focusAfterDelete}
          />
        )}
      </Tag>
    );
  }
}
